// @flow
import * as React from 'react';

import OrganizationCreateContainer from './OrganizationCreateContainer';
import OrganizationCreateForm from './OrganizationCreateForm';

import type { OrganizationType } from 'queries/__generated__/globalGQLTypes';

type Props = {
  onCreate: (*) => void,
  onRequestHide: () => void,
  defaultOrganization?: string,
  organizationType: OrganizationType,
};

class OrganizationCreate extends React.Component<Props, *> {
  render() {
    return (
      <OrganizationCreateContainer>
        {props => (
          <OrganizationCreateForm
            {...props}
            organizationType={this.props.organizationType}
            onCreate={this.props.onCreate}
            onRequestHide={this.props.onRequestHide}
            defaultOrganization={this.props.defaultOrganization}
          />
        )}
      </OrganizationCreateContainer>
    );
  }
}

export default OrganizationCreate;
